import './TimeTravelOverlay.css';

interface TimeTravelOverlayProps {
  /** Destination room name shown under the dial. */
  roomName: string;
  /** Optional error state (travel failed) — flips copy + colors. */
  error?: string | null;
}

/**
 * P3 — the full-screen "time travel" transition shown on both clients while an
 * accepted invite warps them to the target room. Pure CSS (no canvas): a
 * radial clock-dial / starfield vortex. Sits at z 1200 (above the Unity loading
 * veil per the standards z-order registry). Reduced-motion falls back to a fade.
 */
export function TimeTravelOverlay({ roomName, error }: TimeTravelOverlayProps) {
  return (
    <div className={`time-travel-overlay ${error ? 'error' : ''}`} role="status" aria-live="polite">
      <div className="time-travel-dial" aria-hidden="true">
        <span className="tt-ring tt-ring-1" />
        <span className="tt-ring tt-ring-2" />
        <span className="tt-ring tt-ring-3" />
        <span className="tt-core" />
      </div>
      <div className="time-travel-text">
        {error ? (
          <>
            <div className="tt-title">Couldn’t make the jump</div>
            <div className="tt-sub">{error}</div>
          </>
        ) : (
          <>
            <div className="tt-title">Traveling to {roomName}…</div>
            <div className="tt-sub">Folding space between rooms</div>
          </>
        )}
      </div>
    </div>
  );
}

export default TimeTravelOverlay;
